import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";

function AdminInviteForm({
  label,
  name,
  initialValue = "",
  onChange,
  onSubmitEmail,
  placeholder,
  buttonText,
  loading,
}) {
  const [emailValue, setEmailValue] = useState(initialValue);

  useEffect(() => {
    setEmailValue(initialValue);
  }, [initialValue]);

  const handleChange = (event) => {
    const { value } = event.target;
    setEmailValue(value);
    onChange?.(value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const wasSuccessful = await onSubmitEmail?.(emailValue);

    if (wasSuccessful) {
      setEmailValue("");
      onChange?.("");
    }
  };

  return (
    <form
      className="mt-4 space-y-4 lg:mt-5 md:space-y-5"
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col items-end sm:flex-row gap-2 md:gap-6">
        <div className="w-full sm:w-3/4">
          <label className="font-medium text-gray-900">{label}</label>
          <input
            type="email"
            name={name}
            required
            value={emailValue}
            onChange={handleChange}
            placeholder={placeholder}
            className="block w-full mt-2 rounded-md border-0 py-3 pl-4 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-600"
          />
        </div>
        <div className="w-full sm:w-1/4">
          {loading ? (
            <LoadingSpinner />
          ) : (
            <button
              type="submit"
              className="bg-red-500 text-white uppercase rounded px-4 py-2 text-center hover:bg-red-700 cursor-pointer sm:w-full sm:px-4 sm:py-2 sm:text-sm"
              disabled={loading}
            >
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </form>
  );
}

export default AdminInviteForm;
